var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPlus = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 21 20"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M11.243 2.898A.75.75 0 0 0 9.75 3v6.25H3.5l-.102.007A.75.75 0 0 0 3.5 10.75h6.25V17l.007.102A.75.75 0 0 0 11.25 17v-6.25h6.25l.102-.007A.75.75 0 0 0 17.5 9.25h-6.25V3z"
})));
export default SvgPlus;